import { ACCESSIBLE_MUDULE_KEYS } from "../../constants/enum";
import { appNabarRoutes } from "../../router/AppNavbarRoutes";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { Automation } from "./Automation";
import { ManageAutomation } from "./ManageAutomation";

const automationRoute = appNabarRoutes.settings.automation

export const automationRoutes = [
    {
        path: automationRoute,
        exact: true,
        element: (
            <AuthorizedRoute allowFullAccess moduleIds={[]}>
                <Automation />
            </AuthorizedRoute>
        ),
    },
    {
        path: `${automationRoute}/manage-automation`,
        exact: true,
        element: (
            <AuthorizedRoute allowFullAccess moduleIds={[]}>
                <ManageAutomation />
            </AuthorizedRoute>
        ),
    },
    {
        path: `${automationRoute}/manage-automation/:automationCode`,
        exact: true,
        element: (
            <AuthorizedRoute allowFullAccess moduleIds={[]}>
                <ManageAutomation />
            </AuthorizedRoute>
        ),
    },
] 